// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__qXY_h","tab":"ProcedureTabs_tab__3QHQj"};